module.exports = __webpack_public_path__ + "img/44.a348476c.jpg";